import type { ReactNode } from 'react';
import { startTransition } from 'react';

import createEmotionCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { ODTeamBoundary } from 'platform/ODTeamBoundary';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';
import 'preloadQueries';

// Chosen from the upper p75 first-client-query window, before the p95 tail.
const HYDRATE_IDLE_TIMEOUT_MS = 1500;

const emotionCache = createEmotionCache({ key: 'css' });

function ClientCacheProvider({ children }: { children: ReactNode }) {
  return <CacheProvider value={emotionCache}>{children}</CacheProvider>;
}

const hydrate = () => {
  startTransition(() => {
    hydrateRoot(
      document,
      <ODTeamBoundary team="seller">
        <ClientCacheProvider>
          <HydratedRouter />
        </ClientCacheProvider>
      </ODTeamBoundary>,
    );
  });
};

if (typeof requestIdleCallback === 'function') {
  requestIdleCallback(hydrate, { timeout: HYDRATE_IDLE_TIMEOUT_MS });
} else {
  // Safari doesn't support requestIdleCallback
  // https://caniuse.com/requestidlecallback
  setTimeout(hydrate, 1);
}
